angular.module('TurneroApp').component('coMotivosModificar', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '=',
    },
    controller: [
        'motivosService',
        'utilsService',
        'TurneroAppConstant',
        function (motivosService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.motivoEditar = {};

            ctrl.errores = {
                Tipo_Motivo: false,
                N_Motivo: false,
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadModificar = function (item) {
                    ctrl.errores = {
                        Tipo_Motivo: false,
                        N_Motivo: false,
                    };

                    if (item && item.Id_Motivo) {
                        motivosService.get({ 'id_Motivo': item.Id_Motivo }).$promise.then(function (res) {
                            ctrl.motivoEditar = res;
                        }).catch(function (req) {
                            utilsService.errores(req);
                        });
                    }
                }
            }

            ctrl.guardarMotivoEditado = function () {
                ctrl.errores.N_Motivo = !(ctrl.motivoEditar.N_Motivo);
                ctrl.errores.Tipo_Motivo = !(ctrl.motivoEditar.Id_Tipo_Motivo);

                if (ctrl.errores.N_Motivo || ctrl.errores.Tipo_Motivo) {
                    return
                };

                motivosService.update(ctrl.motivoEditar).$promise.then(function (res) {
                    ctrl.ctrlPadre.grillaReload();
                    sweetAlert("Modificar Motivo", "El motivo se modifico correctamente", "success");
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            };

            ctrl.cancelar = function () {
                ctrl.ctrlPadre.grillaReload();
            }
        }
    ],
    template: require('./motivosModificar.html')
});


// WEBPACK FOOTER //
// ./app/components/motivos/motivosModificarComponent.js